import React from 'react'
import { func, bool, string, arrayOf } from 'prop-types'
import {
  CANCEL,
  CONFIRM,
  FINISH,
  MFA_SETTINGS_RECOVERY_CODES_TITLE,
  MFA_SETTINGS_RECOVERY_CODES_CONFIRM_SUBTITLE
} from '../../constants/ui.labels'
import { Modal, ModalContent, Button } from '@cobalt/cobalt-react-components'
import ConfirmDialog from './ConfirmDialog'
import RecoveryOTPConfiguration from '../RecoveryOTPConfiguration/index'
import Wrappers from '../Wrappers/index'

const renderCodes = (otpList, onDismiss) => (
  <Wrappers.Center>
    <RecoveryOTPConfiguration
      otpList={otpList}
      onConfirm={onDismiss}
      requiresConfirm={false}
      confirmText={FINISH}
    />
  </Wrappers.Center>
)

const renderConfirm = (
  onDismiss,
  onConfirm,
  errorMessage,
  isRenewInProgress
) => (
  <ConfirmDialog
    onDismiss={onDismiss}
    onConfirm={onConfirm}
    dismissText={CANCEL}
    confirmText={CONFIRM}
    title={MFA_SETTINGS_RECOVERY_CODES_TITLE}
    subtitle={MFA_SETTINGS_RECOVERY_CODES_CONFIRM_SUBTITLE}
    isCancelDisabled={isRenewInProgress}
    isConfirmDisabled={isRenewInProgress}
    confirmState={isRenewInProgress ? Button.LOADING_STATE : null}
    errorMessage={errorMessage}
  />
)

const RecoveryCodesRenewConfirm = ({
  onDismiss,
  onConfirm,
  errorMessage,
  isRenewInProgress,
  otpList
}) => (
  <Modal small dismissible={!isRenewInProgress} onDismiss={onDismiss}>
    <ModalContent>
      {otpList
        ? renderCodes(otpList, onDismiss)
        : renderConfirm(onDismiss, onConfirm, errorMessage, isRenewInProgress)}
    </ModalContent>
  </Modal>
)

RecoveryCodesRenewConfirm.propTypes = {
  onDismiss: func.isRequired,
  onConfirm: func.isRequired,
  errorMessage: string,
  isRenewInProgress: bool,
  otpList: arrayOf(string)
}

export default RecoveryCodesRenewConfirm
